export default "__VITE_ASSET__6bJY_UyU__"